import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  assignableUsers: [],
  isAssignableUsersLoading: false,
};

const assigneesSlice = createSlice({
  name: "assignees",
  initialState,
  reducers: {
    reset: () => initialState,
    setAssignableUsers(state, { payload }) {
      state.assignableUsers = payload || [];
    },
    setAssignableUsersLoading(state, { payload }) {
      state.isAssignableUsersLoading = Boolean(payload);
    },
  },
});

export const { reset, setAssignableUsers, setAssignableUsersLoading } =
  assigneesSlice.actions;

export default assigneesSlice.reducer;
